import { useMutation, useQueryClient } from "react-query";

import { StudentProgress, Syllabus, Move } from "../../types";
import StudentProgressService from "../../services/StudentProgress";

import { makeQueryKey } from "./useFetchStudentProgress";

function useUpdateStudentProgress() {
  const queryClient = useQueryClient();

  return useMutation(
    ({
      id,
      ...updates
    }: { id: StudentProgress["id"] } & Partial<StudentProgress> & {
        syllabus: Syllabus["id"];
        move: Move["id"];
      }) => StudentProgressService.updateStudentProgressions(id, updates),
    {
      onSuccess: (data, { id }) => {
        queryClient.setQueryData(makeQueryKey(id), data);
      },
    }
  );
}

export default useUpdateStudentProgress;
